import React from 'react';

import type { Props } from '@travel/traveler-core/components/ErrorMessage';
import ErrorMessageCore from '@travel/traveler-core/components/ErrorMessage';

function ErrorMessage(props: Props) {
  return <ErrorMessageCore {...props} />;
}

export default ErrorMessage;
